// extracted by mini-css-extract-plugin
module.exports = {"feature":"styles_feature__22Kf7","feature__list":"styles_feature__list__xgy6O","feature__title":"styles_feature__title__30rD_"};